export const GetRepayment = (coinId) =>
  `/MarginWallet/GetRepayment?CoinId=${coinId}`;

export const GetRepaymentAmountMax = (coinId) =>
  `/MarginWallet/GetRepaymentAmountMax?CoinId=${coinId}`;

export const RepaymentInsert = "/MarginWallet/RepaymentInsert";
